import { axiosClient, getCSRFToken } from 'www/utils'
import { AppointmentButtonStateRequestData } from 'www/vue_components/common/DoctorServicePrices/types'

export function postAppointmentButtonState(data: AppointmentButtonStateRequestData[]) {
  return axiosClient({
    data,
    method: 'POST',
    url: '/ajax/diagnostika/services/schedule/doctors/',
    headers: {
      'X-CSRFToken': getCSRFToken(),
      'Content-Type': 'application/json',
    },
  })
}
